import React, { useReducer, useEffect, useContext} from "react";
import eqpgContext from "./eqpgContex";
import { getAllEqpg, addEqpg, updateEqpg, deleteEqpg } from "../../api/eqpg";
import eqpgReducer from "./eqpgReducer";
import authContext from "../authentication/authContex";

//Types
import {
    ACTUALIZAR_LIST_EQPG,
  } from "./eqpgActions";
import { SocketContext } from "../socket/socket";

const EqpgState = props =>{

    const initialState = {
        eqpgIDLista: []
     };

    const [state, dispatch] = useReducer(eqpgReducer, initialState);
    const server = useContext(SocketContext);
    const auContext = useContext(authContext);
    const {usuario, verificarTenant} = auContext;

    const actualizarEqpgLista = async () => {
        try{
            const resp = await getAllEqpg();
            const eqpg = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_EQPG,
                payload: eqpg
            });
            return eqpg;
        }catch(err){
            console.log(err)
        }
    };

    const agregarEqpg = async (dato) => {
        try{
            const resp = await addEqpg(dato);
            const eqpg = resp.data.data;
            return eqpg;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarEqpg = async (dato) => {
        try{
            const resp = await updateEqpg(dato);
            const eqpg = resp.data.data;
            return eqpg;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarEqpg = async (id, tDocID) => {
        try{
            const resp = await deleteEqpg(id, tDocID);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarEqpgLista();
    },[usuario])

    useEffect(()=>{
            if(server){
                server.on('eqpgsEdited', ({tenantId}) =>{
                    console.log("Recibo el evento del Real Time Server eqpgsEdited");
                    const verification = verificarTenant(tenantId)
                    if(verification){
                        actualizarEqpgLista();
                    }
                })
                return () => {
                    server.off('eqpgsEdited');
                }
            }
        },[server])

    return(
        <eqpgContext.Provider
            value={{
                eqpgIDLista: state.eqpgIDLista,
                actualizarEqpgLista,
                agregarEqpg,
                modificarEqpg,
                eliminarEqpg
            }}
        >
            {props.children}
        </eqpgContext.Provider>
    )

}

export default EqpgState;
